import { tuple } from "./type";
export var PresetStatusColorTypes = tuple("success", "processing", "error", "default", "warning");
// eslint-disable-next-line import/prefer-default-export
export var PresetColorTypes = tuple("pink", "red", "yellow", "orange", "cyan", "green", "blue", "purple", "geekblue", "magenta", "volcano", "gold", "lime");